var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCampaignBackgroundPattern(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 245,
    viewBox: "0 0 160 245",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_310_2832)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 39.3962,
    cy: 39.3962,
    r: 39.1662,
    transform: "matrix(-1 0 0 1 234.396 212.604)",
    stroke: "url(#paint0_linear_310_2832)",
    strokeOpacity: 0.2,
    strokeWidth: 0.459976
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 48.1509,
    cy: 48.1509,
    r: 47.9209,
    transform: "matrix(-1 0 0 1 243.15 203.85)",
    stroke: "url(#paint1_linear_310_2832)",
    strokeOpacity: 0.2,
    strokeWidth: 0.459976
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 55.2641,
    cy: 55.2641,
    r: 55.0341,
    transform: "matrix(-1 0 0 1 250.264 196.736)",
    stroke: "url(#paint2_linear_310_2832)",
    strokeOpacity: 0.2,
    strokeWidth: 0.459976
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 62.9245,
    cy: 62.9245,
    r: 62.6945,
    transform: "matrix(-1 0 0 1 257.926 189.076)",
    stroke: "url(#paint3_linear_310_2832)",
    strokeOpacity: 0.2,
    strokeWidth: 0.459976
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 70.0377,
    cy: 70.0377,
    r: 69.8077,
    transform: "matrix(-1 0 0 1 265.037 181.963)",
    stroke: "url(#paint4_linear_310_2832)",
    strokeOpacity: 0.2,
    strokeWidth: 0.459976
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 78.2453,
    cy: 78.2453,
    r: 78.0153,
    transform: "matrix(-1 0 0 1 273.246 173.754)",
    stroke: "url(#paint5_linear_310_2832)",
    strokeOpacity: 0.2,
    strokeWidth: 0.459976
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 87,
    cy: 87,
    r: 86.77,
    transform: "matrix(-1 0 0 1 282 165)",
    stroke: "url(#paint6_linear_310_2832)",
    strokeOpacity: 0.2,
    strokeWidth: 0.459976
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 39.3962,
    cy: 39.3962,
    r: 39.1662,
    transform: "matrix(-1 0 0 1 4.39648 212.604)",
    stroke: "url(#paint7_linear_310_2832)",
    strokeOpacity: 0.2,
    strokeWidth: 0.459976
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 48.1509,
    cy: 48.1509,
    r: 47.9209,
    transform: "matrix(-1 0 0 1 13.1504 203.85)",
    stroke: "url(#paint8_linear_310_2832)",
    strokeOpacity: 0.2,
    strokeWidth: 0.459976
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 55.2641,
    cy: 55.2641,
    r: 55.0341,
    transform: "matrix(-1 0 0 1 20.2637 196.736)",
    stroke: "url(#paint9_linear_310_2832)",
    strokeOpacity: 0.2,
    strokeWidth: 0.459976
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 62.9245,
    cy: 62.9245,
    r: 62.6945,
    transform: "matrix(-1 0 0 1 27.9258 189.076)",
    stroke: "url(#paint10_linear_310_2832)",
    strokeOpacity: 0.2,
    strokeWidth: 0.459976
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 70.0377,
    cy: 70.0377,
    r: 69.8077,
    transform: "matrix(-1 0 0 1 35.0371 181.963)",
    stroke: "url(#paint11_linear_310_2832)",
    strokeOpacity: 0.2,
    strokeWidth: 0.459976
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 78.2453,
    cy: 78.2453,
    r: 78.0153,
    transform: "matrix(-1 0 0 1 43.2461 173.754)",
    stroke: "url(#paint12_linear_310_2832)",
    strokeOpacity: 0.2,
    strokeWidth: 0.459976
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 87,
    cy: 87,
    r: 86.77,
    transform: "matrix(-1 0 0 1 52 165)",
    stroke: "url(#paint13_linear_310_2832)",
    strokeOpacity: 0.2,
    strokeWidth: 0.459976
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_310_2832",
    x1: 39.3962,
    y1: 0,
    x2: 39.3962,
    y2: 78.7924,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2B13B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2AE32",
    stopOpacity: 0.86
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_310_2832",
    x1: 48.1509,
    y1: 0,
    x2: 48.1509,
    y2: 96.3019,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2B13B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2AE32",
    stopOpacity: 0.86
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_310_2832",
    x1: 55.2641,
    y1: 0,
    x2: 55.2641,
    y2: 110.528,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2B13B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2AE32",
    stopOpacity: 0.86
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_310_2832",
    x1: 62.9245,
    y1: 0,
    x2: 62.9245,
    y2: 125.849,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2B13B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2AE32",
    stopOpacity: 0.86
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_310_2832",
    x1: 70.0377,
    y1: 0,
    x2: 70.0377,
    y2: 140.075,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2B13B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2AE32",
    stopOpacity: 0.86
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_310_2832",
    x1: 78.2453,
    y1: 0,
    x2: 78.2453,
    y2: 156.491,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2B13B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2AE32",
    stopOpacity: 0.86
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_310_2832",
    x1: 87,
    y1: 0,
    x2: 87,
    y2: 174,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2B13B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2AE32",
    stopOpacity: 0.86
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_310_2832",
    x1: 39.3962,
    y1: 0,
    x2: 39.3962,
    y2: 78.7924,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2B13B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2AE32",
    stopOpacity: 0.86
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_310_2832",
    x1: 48.1509,
    y1: 0,
    x2: 48.1509,
    y2: 96.3019,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2B13B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2AE32",
    stopOpacity: 0.86
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_310_2832",
    x1: 55.2641,
    y1: 0,
    x2: 55.2641,
    y2: 110.528,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2B13B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2AE32",
    stopOpacity: 0.86
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_310_2832",
    x1: 62.9245,
    y1: 0,
    x2: 62.9245,
    y2: 125.849,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2B13B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2AE32",
    stopOpacity: 0.86
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_310_2832",
    x1: 70.0377,
    y1: 0,
    x2: 70.0377,
    y2: 140.075,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2B13B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2AE32",
    stopOpacity: 0.86
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_310_2832",
    x1: 78.2453,
    y1: 0,
    x2: 78.2453,
    y2: 156.491,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2B13B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2AE32",
    stopOpacity: 0.86
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_310_2832",
    x1: 87,
    y1: 0,
    x2: 87,
    y2: 174,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2B13B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2AE32",
    stopOpacity: 0.86
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_310_2832"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 160,
    height: 245,
    rx: 4,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCampaignBackgroundPattern);
export default __webpack_public_path__ + "static/media/campaignBackgroundPattern.54ead2fca0f65e4c221cf1981be2a52c.svg";
export { ForwardRef as ReactComponent };